/**
 * Lightweight Plausible event tracker.
 * Safe-guards against the script not being loaded (privacy blockers, dev).
 */
export const trackEvent = (name, props) => {
  try {
    if (typeof window !== "undefined" && typeof window.plausible === "function") {
      window.plausible(name, props ? { props } : undefined);
    }
  } catch (e) {
    /* swallow */
  }
};
